import { render, staticRenderFns } from "./OrderFulfillmentSettings.template.vue?vue&type=template&id=b44979a0&scoped=true&"
var script = {}
import style0 from "./OrderFulfillmentSettings.template.vue?vue&type=style&index=0&id=b44979a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44979a0",
  null
  
)

export default component.exports